module.exports = {
  sm: {
    value: '36rem',
  },
  md: {
    value: '48rem',
  },
  lg: {
    value: '62rem',
  },
  xl: {
    value: '80rem',
  },
  '2xl': {
    value: '87.5rem',
  },
};
